import { routerMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import history from './configureHistory'
import createRootReducer from './reducers'
import sagas from './sagas'

export default function configureStore(preloadedState) {
	const sagaMiddleware = createSagaMiddleware()

	const composeEnhancers =
		process.env.NODE_ENV === 'development' &&
		typeof window === 'object' &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
					//
			  })
			: compose

	const store = createStore(
		createRootReducer(history),
		composeEnhancers(
			applyMiddleware(routerMiddleware(history), sagaMiddleware)
		)
	)

	sagaMiddleware.run(sagas)

	if (module.hot) {
		module.hot.accept('./reducers', () => {
			store.replaceReducer(require('./reducers').default)
		})
	}

	return store
}
